import { useState } from "react";
import { TextField, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

interface PasswordFieldProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: object;
}


export const PasswordField = ({
  label = "Password",
  value,
  onChange,
  sx = {},
}: PasswordFieldProps) => {
  const [show, setShow] = useState(false);

  return (
    <TextField
      fullWidth
      label={label}
      type={show ? "text" : "password"}
      value={value}
      onChange={onChange}
      sx={theme => ({
        ...sx,

        // Hide browser default password icon
        "& input::-ms-reveal, & input::-ms-clear": {
          display: "none",
        },
        "& input::-webkit-textfield-decoration-container": {
          display: "none",
        },
      })}
      InputProps={{
        endAdornment: (
          <IconButton
            onClick={() => setShow(prev => !prev)}
            edge="end"
            sx={theme => ({
              "& svg": {
                filter:
                  theme.palette.mode === "dark"
                    ? "invert(10%) sepia(80%) saturate(200%) hue-rotate(180deg)"
                    : "invert(30%) sepia(40%) saturate(200%) hue-rotate(180deg)",
              },
            })}
          >
            {show ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        ),
      }}
    />
  );
};
